import React, { useState, useEffect } from "react";
import AdminTopBar from "./AdminTopBar"; // Reusing the top bar component
import { useApplicationForm } from "../../Contexts/ApplicationFormContext";
import { db } from "../../Services/firebase-config.js";
import {
  doc,
  collection,
  updateDoc,
  onSnapshot,
  limit,
  query,
  where,
  orderBy,
} from "firebase/firestore";

const ReviewDashboard = () => {
  const { userData } = useApplicationForm();
  // Example data for the reviewer
  // const userData = {
  //   name: "John Doe",
  //   department: "Mobility",
  //   submissionsReceived: 20,
  //   submissionsEvaluated: 12,
  //   teamMembers: ["Jane Smith", "Alice Johnson", "Michael Lee"],
  //   comments: [
  //     "Submission #1: Well-researched, but lacking practical implementation details.",
  //     "Submission #3: Strong proposal, but the budget is overestimated.",
  //   ],
  // };

  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = () => {
    const q = query(
      collection(db, "users"),
      where("department", "==", userData?.department ?? "None"),
      limit(20)
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const users = [];
      querySnapshot.forEach((doc) => {
        users.push(doc.data());
      });
      setTeamMembers(users);
    });

    return unsubscribe;
  };

  useEffect(() => {
    const unsubscribe = fetchTeamMembers();

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <AdminTopBar title="Review Dashboard" />

      <div className="container mx-auto p-6 space-y-6">
        {/* Reviewer's Name and Department */}
        <div className="bg-white shadow p-6 ">
          <h2 className="text-2xl font-bold mb-2">
            Reviewer: {userData.displayName}
          </h2>
          <p className="text-gray-700">
            Department (Bureau): {userData?.department}
          </p>
        </div>

        {/* Submissions Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Submissions Received */}
          <div className="bg-blue-100 text-blue-900 p-6  shadow">
            <h3 className="text-lg font-bold mb-2">Submissions Received</h3>
            <p className="text-4xl font-semibold">
              {userData.submissionsReceived ?? 0}
            </p>
          </div>

          {/* Submissions Evaluated */}
          <div className="bg-green-100 text-green-900 p-6  shadow">
            <h3 className="text-lg font-bold mb-2">Submissions Evaluated</h3>
            <p className="text-4xl font-semibold">
              {userData.submissionsEvaluated ?? 0}
            </p>
          </div>
        </div>

        {/* Team Members */}
        <div className="bg-white shadow p-6 ">
          <h3 className="text-lg font-bold mb-4">
            Team Members in {userData?.department}
          </h3>
          <ul className="list-disc pl-6 space-y-2">
            {teamMembers.map((member, index) => (
              <li key={index} className="text-gray-700">
                {member.displayName}
              </li>
            ))}

            {teamMembers.length === 0 && (
              <p className="text-gray-700">No team members found.</p>
            )}
          </ul>
        </div>

        {/* Comments on Reviews */}
        <div className="bg-white shadow p-6 ">
          <h3 className="text-lg font-bold mb-4">Comments on Reviews</h3>
          <ul className="list-disc pl-6 space-y-2">
            {userData.comments?.map((comment, index) => (
              <li key={index} className="text-gray-700">
                {comment}
              </li>
            ))}

            {userData.comments?.length === 0 && (
              <p className="text-gray-700">No comments found.</p>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ReviewDashboard;
